<!-- vertical layout -->
<app-vertical *ngIf="isVerticalLayoutRequested()"></app-vertical>
<app-horizontal *ngIf="isHorizontalLayoutRequested()"></app-horizontal>
